import { useEffect } from 'react';
import styles from './index.module.css';
import VideoAlert from '../video-alert';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const Header = ({ textData,language }) => {
  const ctnRef = useRef(null);
  const img1Ref = useRef(null)
  const img2Ref = useRef(null)
  const img3Ref = useRef(null)
  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.watchVideoButton}`,
    });
  }, []);

  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        end: '40%',
        scrub: 1.5,
        pin: true,
      },
    });

    tl.to(img1Ref.current,{
      y: -100,
    });

    tl.to(img2Ref.current,{
      y: -60,
    },0);

    tl.to(img3Ref.current,{
      y: -30,
    },0);
  }, []);
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <img
        ref={img1Ref}
        src={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-home-01-${language}.svg`}
        alt=""
      />
      <img
        ref={img2Ref}
        src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-home-02.png"
        alt=""
      />
      <img
        ref={img3Ref}
        src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-home-03.png"
        alt=""
      />

      <div
        className={styles.watchVideoButton}
        data-video-src={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-tvc-${language === 'cn' ? 'cn' : 'en'}.mp4`}
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.55566 16.2536V4.74625C5.55566 3.86948 6.52361 3.33813 7.2633 3.80885L16.3048 9.56254C16.9909 9.99916 16.9909 11.0007 16.3048 11.4373L7.2633 17.191C6.52361 17.6618 5.55566 17.1304 5.55566 16.2536Z"
          />
        </svg>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text1']),
          }}
        ></div>
      </div>
    </div>
  );
};

export default Header;
